"use strict";

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DeserializationError_1 = __importDefault(require("../../Errors/DeserializationError"));

var SerializationError_1 = __importDefault(require("../../Errors/SerializationError"));

var FixedParser = /*#__PURE__*/function () {
  function FixedParser(size) {
    _classCallCheck(this, FixedParser);

    this.size = size;
  }

  _createClass(FixedParser, [{
    key: "deserialize",
    value: function deserialize(state) {
      state.position += this.size;
      var data = state.data.slice(state.position - this.size, state.position);

      if (data.length !== this.size) {
        throw new DeserializationError_1.default('FixedParser: read past end');
      }

      return data;
    }
  }, {
    key: "serialize",
    value: function serialize(data) {
      if (data.length !== this.size) {
        throw new SerializationError_1.default("input data does not conform fixed size");
      }

      return data;
    }
  }]);

  return FixedParser;
}();

exports.default = FixedParser;